import {
  externalConfirmationPathSelector,
  internalConfirmationPathSelector
} from 'selectors/url'
import { eventTypeSelector } from 'root-api'

export const navigateToConfirmationPage = (formData) => (dispatch, getState, { history }) => {
  const state = getState()
  switch (eventTypeSelector(state).confirmation_page_type) {
    case 'internal':
      history.push(internalConfirmationPathSelector(state))
      break
    case 'external':
      dispatch({ type: 'SCHEDULING_SHOW_EXTERNAL_REDIRECT' })
      setTimeout(
        () => {
          window.top.location.href = externalConfirmationPathSelector(state, { formData })
        },
        3000
      )
      break
    default:
      throw new Error('Unsupported confirmation page type')
  }
}
